import { compose } from "redux";
import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";
import { IAction } from "../../../models/Action";
import { immutableSet } from "../../../utils/immutable";
import { actionTypes } from "./actions";
import emptyState from "./emptyState";

import { IRequestUsers } from "../../../models/Entitlements";
import {
  LIST_IDENTIFIER,
  LOADER_IDENTIFIER,
  SHOW_TABLE_IDENTIFIER,
  STATE_IDENTIFIER,
} from "./constants";
import { IDENTITY_SYSTEM } from "../../../module/constants";

const {
  ADDED_BR,
  ADDED_ENTITLEMENTS,
  BUSINESS_ROLES,
  DELEGATOR,
  DELETED_BR,
  DELETED_ENTITLEMENTS,
  ENTITLEMENTS,
  IS_SELF_SELECTED,
  MODIFIED_BR,
  MODIFIED_ENTITLEMENTS,
  OFFICES,
  PREV_ENTITLEMENTS,
  SELECTED_OFFICE,
  SELECTED_USER,
  STEP_FOUR,
  STEP_ONE,
  STEP_THREE,
  STEP_TWO,
  TOTAL_ENTITLEMENTS,
  USER,
  CALL_STATE,
  COMMENT,
  ENTITLEMENTS_BR_SELECTED,
  EXISTING_SAME_DB,
  ATTACHMENTS,
  LIST_FULL,
  IS_COMMENT_COMPULSORY,
  SOD_CONFLICTS,
  START_END_DATE,
  PAGINATED_BUSINESS_ROLES,
  PAGINATED_ENTITLEMENTS,
  SOD_COMMENT,
} = STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.SELECT_OFFICE]: (state: any, action: any) =>
    compose(
      immutableSet([SELECTED_USER], []),
      immutableSet([SELECTED_OFFICE], action.id)
    )(state),
  [actionTypes.MODIFY_SELF_SELECTED]: (state: any, action: any) =>
    compose(
      immutableSet([SELECTED_USER], []),
      immutableSet([IS_SELF_SELECTED], action.isSelfSelected)
    )(state),
  [actionTypes.MODIFY_DELEGATOR]: (state: any, action: any) =>
    immutableSet([STEP_FOUR, DELEGATOR], action.code, state),

  [actionTypes.MODIFY_SELECTED_USERS]: (state: any, action: any) =>
    immutableSet([SELECTED_USER], action.selectedUsers, state),

  [actionTypes.MODIFY_ADDED_ABILITATIONS]: (state: any, action: any) => {
    return immutableSet([ADDED_ENTITLEMENTS], action.addedAbilitations, state);
  },
  [actionTypes.MODIFY_SOD_COMMENT]: (state: any, action: any) =>
          immutableSet([STEP_FOUR, SOD_COMMENT], action.sodComment, state),
  
  [actionTypes.MODIFY_ADDED_BR]: (state: any, action: any) =>
    immutableSet([ADDED_BR], action.addedBR, state),

  [actionTypes.MODIFY_DELETED_ABILITATIONS]: (state: any, action: any) =>
    immutableSet([DELETED_ENTITLEMENTS], action.deletedAbilitations, state),

  [actionTypes.MODIFY_MODIFIED_ABILITATIONS]: (state: any, action: any) =>
    immutableSet([MODIFIED_ENTITLEMENTS], action.modifiedAbilitations, state),

  [actionTypes.MODIFY_TOTAL_ABILITATIONS]: (state: any, action: any) =>
    immutableSet(
      [STEP_THREE, TOTAL_ENTITLEMENTS],
      action.totalAbilitations,
      state
    ),

  [actionTypes.MODIFY_COMMENT]: (state: any, action: any) =>
    immutableSet([STEP_FOUR, COMMENT], action.comment, state),

  [actionTypes.OFFICE_REQUEST]: (state: any, action: any) =>
    immutableSet([STEP_ONE, OFFICES, LOADER_IDENTIFIER], true, state),
  [actionTypes.OFFICE_REQUEST_SUCCESS]: (state: any, action: any) =>
    compose(
      immutableSet([STEP_ONE, OFFICES, LIST_IDENTIFIER], action.payload),
      immutableSet([STEP_ONE, OFFICES, LOADER_IDENTIFIER], false)
    )(state),

  [actionTypes.OFFICE_REQUEST_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet([STEP_ONE, OFFICES, LIST_IDENTIFIER], []),
      immutableSet([STEP_ONE, OFFICES, LOADER_IDENTIFIER], false)
    )(state),

  [actionTypes.USER_REQUEST]: (state: any, action: any) =>
    immutableSet([STEP_TWO, USER, LOADER_IDENTIFIER], true, state),

  [actionTypes.USER_REQUEST_SUCCESS]: (state: any, action: any) => {
    const tempUsers: any[] = [];
    action.payload.map((user: IRequestUsers) => {
      const tempUser = {
        identitySystemId:
          IDENTITY_SYSTEM[
            user.identitySystemId as keyof typeof IDENTITY_SYSTEM
          ],
        id_user: user.id,
        code: user.code,
        name: user.name,
        surname: user.surname,
        organizational_unit: user.organizational_unit,
        resp_code: user.resp_code,
        type: user.type,
        company: user.company,
      };
      tempUsers.push(tempUser);
    });
    return compose(
      immutableSet([STEP_TWO, USER, LIST_IDENTIFIER], tempUsers),
      immutableSet([STEP_TWO, USER, LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.USER_REQUEST_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet([STEP_TWO, USER, LIST_IDENTIFIER], []),
      immutableSet([STEP_TWO, USER, LOADER_IDENTIFIER], false)
    )(state),

  [actionTypes.OFFICE_ENTITLEMENT_REQUEST]: (state: any, action: any) =>
    immutableSet([STEP_THREE, ENTITLEMENTS, LOADER_IDENTIFIER], true, state),

  [actionTypes.OFFICE_ENTITLEMENT_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let mappedResponse: any[] = [];
    let mappedResponseFull: any[] = [];
    action.payload.length > 0 &&
      action.payload
        .filter((entitlement: any) => entitlement.showOnFrontend)
        .forEach((data: any) => {
          const tempRow: {} = {
            entitlement_id: data.entitlement_id,
            application_name: data.application_name,
            application_description: data.application_description,
            entitlement_name: data.entitlement_name,
            entitlement_description: data.entitlement_description,
            application_id: data.application_id,
            identitySystemId: data.identity_system_id,
            chainEntitlements: data.chainEntitlements,
            chainEntitlementsIds: data.chainEntitlementsIds,
            editable: data.editable,
            deleted: false,
            added: false,
            validable: data.validable,
            monoProfilo: data.monoProfilo,
            involvedInSOD: data.involvedInSOD,
            temporary: data.temporary,
            whitelist: data.whitelist,
          };
          mappedResponse.push(tempRow);
        });
    action.payload.length > 0 &&
      action.payload.forEach((data: any) => {
        const tempRow: {} = {
          entitlement_id: data.entitlement_id,
          application_name: data.application_name,
          application_description: data.application_description,
          entitlement_name: data.entitlement_name,
          entitlement_description: data.entitlement_description,
          application_id: data.application_id,
          identitySystemId: data.identity_system_id,
          chainEntitlements: data.chainEntitlements,
          chainEntitlementsIds: data.chainEntitlementsIds,
          editable: data.editable,
          deleted: false,
          added: false,
          validable: data.validable,
          monoProfilo: data.monoProfilo,
          involvedInSOD: data.involvedInSOD,
          temporary: data.temporary,
          whitelist: data.whitelist,
        };
        mappedResponseFull.push(tempRow);
      });
    return compose(
      immutableSet([STEP_THREE, ENTITLEMENTS, LIST_IDENTIFIER], mappedResponse),
      immutableSet([STEP_THREE, ENTITLEMENTS, LIST_FULL], mappedResponseFull),
      immutableSet([STEP_THREE, ENTITLEMENTS, LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.OFFICE_ENTITLEMENT_REQUEST_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet([STEP_THREE, ENTITLEMENTS, LIST_IDENTIFIER], []),
      immutableSet([STEP_THREE, ENTITLEMENTS, LOADER_IDENTIFIER], false)
    )(state),

  [actionTypes.OFFICE_PAGINATED_ENTITLEMENT_REQUEST]: (
    state: any,
    action: any
  ) => immutableSet([STEP_THREE, ENTITLEMENTS, LOADER_IDENTIFIER], true, state),

  [actionTypes.OFFICE_PAGINATED_ENTITLEMENT_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    const { entitlementsOu, ...paginationData } = action.payload;
    let mappedResponse: any[] = [];
    let mappedResponseFull: any[] = [];
    entitlementsOu.length > 0 &&
      entitlementsOu
        .filter((entitlement: any) => entitlement.showOnFrontend)
        .forEach((data: any) => {
          const tempRow: {} = {
            entitlement_id: data.entitlement_id,
            application_name: data.application_name,
            application_description: data.application_description,
            entitlement_name: data.entitlement_name,
            entitlement_description: data.entitlement_description,
            application_id: data.application_id,
            identity_system_id: data.identity_system_id,
            identitySystemId:
              IDENTITY_SYSTEM[
                data.identity_system_id as keyof typeof IDENTITY_SYSTEM
              ],
            chainEntitlements: data.chainEntitlements,
            chainEntitlementsIds: data.chainEntitlementsIds,
            editable: data.editable,
            deleted: false,
            added: false,
            validable: data.validable,
            monoProfilo: data.monoProfilo,
            involvedInSOD: data.involvedInSOD,
            temporary: data.temporary,
            whitelist: data.whitelist,
          };
          mappedResponse.push(tempRow);
        });
    entitlementsOu.length > 0 &&
      entitlementsOu.forEach((data: any) => {
        const tempRow: {} = {
          entitlement_id: data.entitlement_id,
          application_name: data.application_name,
          application_description: data.application_description,
          entitlement_name: data.entitlement_name,
          entitlement_description: data.entitlement_description,
          application_id: data.application_id,
          identity_system_id: data.identity_system_id,
          identitySystemId:
            IDENTITY_SYSTEM[
              data.identity_system_id as keyof typeof IDENTITY_SYSTEM
            ],
          chainEntitlements: data.chainEntitlements,
          chainEntitlementsIds: data.chainEntitlementsIds,
          editable: data.editable,
          deleted: false,
          added: false,
          validable: data.validable,
          monoProfilo: data.monoProfilo,
          involvedInSOD: data.involvedInSOD,
          temporary: data.temporary,
          whitelist: data.whitelist,
        };
        mappedResponseFull.push(tempRow);
      });

    const entitlementsRawData = {
      entitlementsOu: mappedResponse,
      ...paginationData,
    };

    return compose(
      immutableSet([STEP_THREE, PAGINATED_ENTITLEMENTS], entitlementsRawData),
      immutableSet([STEP_THREE, ENTITLEMENTS, LIST_FULL], mappedResponseFull),
      immutableSet([STEP_THREE, ENTITLEMENTS, LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.OFFICE_PAGINATED_ENTITLEMENT_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) =>
    compose(
      immutableSet([STEP_THREE, PAGINATED_ENTITLEMENTS], {}),
      immutableSet([STEP_THREE, ENTITLEMENTS, LOADER_IDENTIFIER], false)
    )(state),

  [actionTypes.OFFICE_PAGINATED_BR_REQUEST]: (state: any, action: any) =>
    immutableSet([STEP_THREE, BUSINESS_ROLES, LOADER_IDENTIFIER], true, state),

  [actionTypes.OFFICE_PAGINATED_BR_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    const { businessRoleOu, ...paginationData } = action.payload;
    let mappedResponse: any[] = [];
    businessRoleOu.length > 0 &&
      businessRoleOu.forEach((data: any) => {
        let involvedInSOD = false;
        let brEntitlements: any[] = [];
        data.entitlements?.forEach((element: any) => {
          if (element.involvedInSOD) involvedInSOD = true;
          brEntitlements.push({
            ...element,
            identitySystemId:
              IDENTITY_SYSTEM[
                (element.identity_system_id ||
                  element.identitySystemId) as keyof typeof IDENTITY_SYSTEM
              ],
          });
        });
        const tempRow: any = {
          entitlement_id: data.codeBusinessRole,
          application_name: data.name,
          application_description: data.description,
          entitlement_name: null,
          entitlement_description: null,
          entitlements: brEntitlements,
          validable: null,
          involvedInSOD: involvedInSOD,
          identitySystemId: "",
        };
        if (data.entitlements && data.entitlements.length > 0) {
          tempRow.isBR = true;
        }
        mappedResponse.push(tempRow);
      });

    const businessRoleRawData = {
      businessRoleOu: mappedResponse,
      ...paginationData,
    };

    return compose(
      immutableSet([STEP_THREE, PAGINATED_BUSINESS_ROLES], businessRoleRawData),
      immutableSet([STEP_THREE, BUSINESS_ROLES, LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.OFFICE_ENTITLEMENT_REQUEST_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet([STEP_THREE, PAGINATED_BUSINESS_ROLES], {}),
      immutableSet([STEP_THREE, BUSINESS_ROLES, LOADER_IDENTIFIER], false)
    )(state),

  [actionTypes.BAO_ENTITLEMENT_REQUEST]: (state: any, action: any) =>
    immutableSet([STEP_THREE, BUSINESS_ROLES, LOADER_IDENTIFIER], true, state),

  [actionTypes.BAO_ENTITLEMENT_REQUEST_SUCCESS]: (state: any, action: any) => {
    let mappedResponse: any[] = [];
    action.payload.length > 0 &&
      action.payload.forEach((data: any) => {
        let involvedInSOD = false;
        data.entitlements?.forEach((element: any) => {
          if (element.involvedInSOD) involvedInSOD = true;
        });
        const tempRow: {} = {
          entitlement_id: data.codeBusinessRole,
          application_name: data.name,
          application_description: data.description,
          entitlement_name: null,
          entitlement_description: null,
          entitlements: data.entitlements,
          validable: null,
          involvedInSOD: involvedInSOD,
        };
        mappedResponse.push(tempRow);
      });

    return compose(
      immutableSet(
        [STEP_THREE, BUSINESS_ROLES, LIST_IDENTIFIER],
        mappedResponse
      ),
      immutableSet([STEP_THREE, BUSINESS_ROLES, LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.BAO_ENTITLEMENT_REQUEST_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet([STEP_THREE, BUSINESS_ROLES, LIST_IDENTIFIER], []),
      immutableSet([STEP_THREE, BUSINESS_ROLES, LOADER_IDENTIFIER], false)
    )(state),

  [actionTypes.ENTITLEMENT_REQUEST]: (state: any, action: any) =>
    immutableSet(
      [STEP_THREE, PREV_ENTITLEMENTS, LOADER_IDENTIFIER],
      true,
      state
    ),

  [actionTypes.MODIFY_REMOVED_BR]: (state: any, action: any) =>
    immutableSet([DELETED_BR], action.removedBR, state),

  [actionTypes.ENTITLEMENT_REQUEST_SUCCESS]: (state: any, action: any) => {
    return compose(
      immutableSet([STEP_THREE, PREV_ENTITLEMENTS, LIST_IDENTIFIER], {
        entitlements: action.payload.entitlements.filter(
          (entitlement: any) => entitlement.showOnFrontend
        ),
        businessRoles: action.payload.businessRoles,
      }),
      immutableSet([STEP_THREE, PREV_ENTITLEMENTS, LOADER_IDENTIFIER], false),
      immutableSet([STEP_THREE, TOTAL_ENTITLEMENTS], {
        entitlements: action.payload.entitlements.filter(
          (entitlement: any) => entitlement.showOnFrontend
        ),
        businessRoles: action.payload.businessRoles,
      })
    )(state);
  },

  [actionTypes.ENTITLEMENTS_BUSINESS_ROLES_SELECTED]: (
    state: any,
    action: any
  ) => {
    return compose(
      immutableSet(
        [STEP_THREE, ENTITLEMENTS_BR_SELECTED, LIST_IDENTIFIER],
        action.payload
      ),
      immutableSet(
        [STEP_THREE, ENTITLEMENTS_BR_SELECTED, SHOW_TABLE_IDENTIFIER],
        true
      )
    )(state);
  },

  [actionTypes.ENTITLEMENTS_BUSINESS_ROLES_SELECTED_RESET]: (
    state: any,
    action: any
  ) =>
    compose(
      immutableSet([STEP_THREE, ENTITLEMENTS_BR_SELECTED, LIST_IDENTIFIER], []),
      immutableSet(
        [STEP_THREE, ENTITLEMENTS_BR_SELECTED, SHOW_TABLE_IDENTIFIER],
        false
      )
    )(state),

  [actionTypes.ENTITLEMENT_REQUEST_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet([STEP_THREE, PREV_ENTITLEMENTS, LIST_IDENTIFIER], {
        businessRoles: [],
        entitlements: [],
      }),
      immutableSet([STEP_THREE, PREV_ENTITLEMENTS, LOADER_IDENTIFIER], false),
      immutableSet([STEP_THREE, TOTAL_ENTITLEMENTS], [])
    )(state),

  [actionTypes.CREATE_REQUEST_SUCCESS]: (state: any, action: any) =>
    immutableSet([STEP_FOUR, CALL_STATE], IResponseState.SUCCESS, state),

  [actionTypes.CREATE_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet([STEP_FOUR, CALL_STATE], IResponseState.ERROR, state),
  [actionTypes.SET_EXISTING_SAME_DB]: (state: any, action: any) =>
    immutableSet([EXISTING_SAME_DB], action.payload, state),

  [actionTypes.SET_IS_COMMENT_COMPULSORY_ACTION]: (state: any, action: any) =>
    immutableSet([STEP_FOUR, IS_COMMENT_COMPULSORY], action.payload, state),

  [actionTypes.SOD_CONFLICTS_SUCCESS]: (state: any, action: any) =>
    immutableSet([SOD_CONFLICTS], action.payload, state),

  [actionTypes.SOD_CONFLICTS_FAILURE]: (state: any, action: any) =>
    immutableSet([SOD_CONFLICTS], IResponseState.ERROR, state),

  [actionTypes.RESET_SOD_CONFLICTS]: (state: any, action: any) =>
    immutableSet([SOD_CONFLICTS], null, state),

  [actionTypes.RESET_ABILITATIONS]: (state: any, action: any) =>
    compose(
      immutableSet([STEP_THREE, PREV_ENTITLEMENTS, LIST_IDENTIFIER], {
        businessRoles: [],
        entitlements: [],
      }),
      immutableSet([STEP_THREE, ENTITLEMENTS, LIST_IDENTIFIER], []),
      immutableSet([ADDED_ENTITLEMENTS], []),
      immutableSet([DELETED_ENTITLEMENTS], []),
      immutableSet([MODIFIED_ENTITLEMENTS], []),
      immutableSet([DELETED_BR], []),
      immutableSet([MODIFIED_BR], []),
      immutableSet([ADDED_BR], []),
      immutableSet([STEP_THREE, TOTAL_ENTITLEMENTS], {
        businessRoles: [],
        entitlements: [],
      })
    )(state),

  [actionTypes.RESET_STATE]: (state: any, action: any) => emptyState,

  [actionTypes.ABILITATION_MANAGEMENT_SET_START_END_DATE]: (
    state: any,
    action: any
  ) => {
    let obj = {
      id: action.payload.id,
      startDate: action.payload.startDate,
      endDate: action.payload.endDate,
    };
    let data: any[] = state.stepThree.startEndDate;
    data.push(obj);
    return immutableSet([START_END_DATE], data, state);
  },
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    action.payload.location.pathname === "/welcome"
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
